import React, { useContext } from "react";
import { AgGridReact } from "ag-grid-react";
import { IWorkorder } from "../../../../app/models/workorder";
import { observer } from "mobx-react-lite";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import oneOrderStore from "../../../../app/stores/oneOrderStore";

interface IProps {
  workorders: IWorkorder[];
}

  //ADD 230811 for checking user

const WorkOrderGrid: React.FC<IProps> = props => {
  const workorderStore = useContext(oneOrderStore);
  const { selectWorkOrder } = workorderStore;
  


    
  const GetSelectedRow = (params: any) => {
    if (params.node.selected === true) {
      var JobId: string = params.node.data.JobId;
      let sessionObj = JSON.parse(sessionStorage.getItem("sessionObj")!) 

      //Pass this to store
      selectWorkOrder(JobId,sessionObj.User.Username);
    }
  };
  const onGridReady = (params: any) => {
    params.api.sizeColumnsToFit();

    
    
}





  return (
    <div className="table-responsive">
      <div
        className="ag-theme-material"
        style={{ height: "400px", width: "auto" }}
      > 
      <div>
      </div>
        <AgGridReact
          enableSorting={true}
          enableColResize={true}
          rowSelection={"single"}
          onGridReady={onGridReady}
          pagination={true}
          floatingFilter={true}
          onRowSelected={GetSelectedRow}
          suppressPaginationPanel={true}
          //rowModelType={"infinite"}
          columnDefs={[
            {
              headerName: "Client Ref",
              field: "ClientRef",
              width: 150,
              filter:true,
              suppressMenu:true
            },

            { headerName: "Job No", field: "JobNo", width: 150,filter:true,suppressMenu:true},
            { headerName: "Job Substatus", field: "JobSubStatus",filter:true,suppressMenu:true},
            {
              headerName: "Raised Date",
              field: "DateRaised",
              type: "dateColumn",
              sort: "desc",
              valueFormatter: dateFormatterNoDaylight,filter:true,suppressMenu:true
            },

            {
              headerName: "Target Date",
              field: "TargetDate",
              type: "dateColumn",
              valueFormatter: dateFormatterNoDaylight,filter:true,suppressMenu:true
              
            },
            { headerName: "Job Value", field: "JobValue", valueFormatter: currencyFormatter,filter:true,suppressMenu:true }
          ]}
          rowData={props.workorders}
          
        ></AgGridReact>
      </div>
      
    </div>
  );
};



function dateFormatter(params:any) {
  var date = new Date(params.value);
  return date.toLocaleString();
}

function dateFormatterNoDaylight(params:any) {
  if(params.value){
    var formatdate = (params.value).replace("T", " ").replace("Z", "");
    return formatdate.toString();
  }
  else{
    return (params.value);
  }
}

function currencyFormatter(params:any) {
  return "\xA3" + params.value.toFixed(2);
}

export function currentPage () {


}



export default observer(WorkOrderGrid);

